import Nav from "@/components/Nav";
import Seo from "@/components/Seo";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ title, lastUpdated, sections, seoDescription }) {
  return (
    <div data-testid="legal-page" className="min-h-screen bg-[var(--bg)] text-[var(--text-1)]">
      <Seo
        title={`${title} · KS DevArc`}
        description={seoDescription || title}
        url={typeof window !== "undefined" ? window.location.href : ""}
      />
      <Nav />
      <article className="relative pt-36 pb-32">
        <div className="absolute inset-0 grid-bg opacity-15 pointer-events-none" />
        <div className="relative mx-auto max-w-3xl px-5 sm:px-8">
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 font-mono-ui text-[11px] tracking-[0.22em] uppercase text-[var(--text-3)] hover:text-[var(--text-1)] mb-10"
          >
            <ArrowLeft className="w-3 h-3" /> Back to home
          </Link>

          <div className="flex items-center gap-3 mb-6">
            <span className="w-2 h-2 bg-[var(--lime)] rounded-full" />
            <span className="overline">— Legal</span>
          </div>

          <h1
            data-testid="legal-title"
            className="font-display font-black text-4xl md:text-6xl tracking-tight leading-[0.95]"
          >
            {title}
          </h1>

          <div className="mt-4 font-mono-ui text-[11px] tracking-[0.22em] uppercase text-[var(--text-3)]">
            Last Updated: {lastUpdated}
          </div>

          <div className="mt-14 space-y-10">
            {sections.map((s, i) => (
              <section
                key={i}
                data-testid={`legal-section-${i + 1}`}
                className="border-t border-[var(--border-dim)] pt-8"
              >
                <div className="grid grid-cols-12 gap-4 md:gap-8">
                  <div className="col-span-12 md:col-span-3">
                    <div className="font-display font-black text-2xl md:text-3xl text-[var(--vermilion)] leading-none">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                  </div>
                  <div className="col-span-12 md:col-span-9">
                    <h2 className="font-display font-bold text-xl md:text-2xl tracking-tight mb-3">
                      {s.heading}
                    </h2>
                    {Array.isArray(s.body) ? (
                      <div className="space-y-3">
                        {s.body.map((p, j) => (
                          <p
                            key={j}
                            className="text-[var(--text-2)] text-sm md:text-base leading-relaxed whitespace-pre-line"
                          >
                            {p}
                          </p>
                        ))}
                      </div>
                    ) : (
                      <p className="text-[var(--text-2)] text-sm md:text-base leading-relaxed whitespace-pre-line">
                        {s.body}
                      </p>
                    )}
                  </div>
                </div>
              </section>
            ))}
          </div>
        </div>
      </article>
    </div>
  );
}
